import React, { Component } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";

// Operator → URL suffix used by backend extraFilters parser.
// '=' / '' = exact match (no suffix). See widgetdefinition::get_widget_data().
const OPERATOR_SUFFIX = {
  "=": "",
  "": "",
  ">=": "gte",
  "<=": "lte",
  ">": "gt",
  "<": "lt",
  "!=": "ne",
  "CONTAINS": "like",
  "BETWEEN": "between",
};

/**
 * SearchFilterAdapter - Search/filter form that emits filter_applied events.
 *
 * filterConfig.fields[] shape:
 *   { fieldName, displayName, inputType, operator, placeholder, colSpan }
 * - fieldName MUST match a column in the chart's target table.
 * - operator defaults to "=" (exact match). For date ranges, declare two
 *   fields on the same fieldName with operators ">=" and "<=".
 */
export default class SearchFilterAdapter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterValues: {},
    };
  }

  // Unique storage key per field so two fields on the same column with
  // different operators (e.g. createdOn >= / createdOn <=) don't collide.
  getFieldKey = (field) => {
    const op = (field.operator || "=").toString();
    const suffix = OPERATOR_SUFFIX[op.toUpperCase()] != null
      ? OPERATOR_SUFFIX[op.toUpperCase()]
      : OPERATOR_SUFFIX[op];
    return suffix ? `${field.fieldName}__${suffix}` : field.fieldName;
  };

  handleFilterChange = (key, value) => {
    this.setState((prev) => ({
      filterValues: { ...prev.filterValues, [key]: value },
    }));
  };

  handleApply = () => {
    if (this.props.onEvent) {
      this.props.onEvent("filter_applied", this.props.config.widget_instances_Id, this.state.filterValues);
    }
  };

  handleClear = () => {
    this.setState({ filterValues: {} });
    if (this.props.onEvent) {
      this.props.onEvent("filter_cleared", this.props.config.widget_instances_Id, {});
    }
  };

  render() {
    const { config } = this.props;
    const filterConfig = config.filterConfig || {};
    const fields = filterConfig.fields || [];

    return (
      <div className="search-filter-widget p-3 bg-light rounded mb-3">
        <Row>
          {fields.map((field, idx) => {
            const key = this.getFieldKey(field);
            return (
              <Col key={`${key}-${idx}`} md={field.colSpan || 3} className="mb-2">
                <Form.Label style={{ fontSize: "0.875rem" }}>
                  {field.displayName || field.fieldName}
                </Form.Label>
                <Form.Control
                  type={(field.inputType || "text").toLowerCase()}
                  size="sm"
                  value={this.state.filterValues[key] || ""}
                  onChange={(e) => this.handleFilterChange(key, e.target.value)}
                  placeholder={field.placeholder || `Filter by ${field.displayName || field.fieldName}`}
                />
              </Col>
            );
          })}
          <Col md={2} className="d-flex align-items-end mb-2">
            <Button variant="primary" size="sm" className="me-2" onClick={this.handleApply}>
              <i className="bi bi-search me-1"></i>Apply
            </Button>
            <Button variant="outline-secondary" size="sm" onClick={this.handleClear}>
              Clear
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}
